module.exports = __webpack_public_path__ + "static/2019523:2c1962ccc3a792554197/img/passion_3x.cbd8d2d.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/passion_3x.png
// module id = 4Y9k
// module chunks = 1